module.exports = __webpack_public_path__ + "img/bg.f407e1d.jpg";